









































































import { Component, Vue, Watch, Ref } from 'vue-property-decorator';

import {authStore} from '@/libs/auth/+store/store';
import { AuthAction, AuthGetter } from '@/libs/auth/models/auth-state';
import { SignInModel } from '@/libs/auth/models/auth-models';

import { ToastPlugin } from '@syncfusion/ej2-vue-notifications';
import { ToastComponent } from '@syncfusion/ej2-vue-notifications';
import Page from '@/Page.vue';
import { tenantsStore } from '@/libs/tenants/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { TenantModel } from '@/libs/Api';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { enumerateObject } from 'linq-to-typescript';
Vue.use(ToastPlugin);

@Component({
  components: {
    ToastComponent
  }
})
export default class SignIn extends Page {
    email = null;
    password = null;
    code = null;
    pending = false;
    basicRules = [
        (v: any) => !!v || this.$t('validation.thisFieldIsRequired')
    ];
    valid = false;
    showToastSuccess = false;
    showToastError = false;
    sending: boolean | null = null;
    error: string | null = null;
    twoFactorAuth = false;

    @Ref() form!: any;
    
    mounted() {
        if (authStore.useGetter(AuthGetter.GetIsLoggedIn)) {
            this.$router.replace({ name: "Home" });
            return;
        } else {
            if (typeof this.$route.query.recoverySuccess != "undefined" && this.$route.query.recoverySuccess != null) {
                if (this.$route.query.recoverySuccess == "true" || this.$route.query.recoverySuccess) {
                    this.showToastSuccess = true;
                } else {
                    this.showToastError = true;
                }
            }
        }
    }

    submit () {
        if (this.form.validate()) {
            const payload = new SignInModel();
            payload.email = this.email;
            payload.password = this.password;
            this.sending = true;
            this.error = null;
            authStore.dispatch(AuthAction.SignIn, payload);
            const self = this;
            const createdSubscriber = this.$store.subscribe((mutation, _state) => {
                if(mutation.type === authStore.getActionName(AuthAction.SignInResponse)) {
                    createdSubscriber();
                    self.sending = false;
                    if (typeof mutation.payload.error != undefined && mutation.payload.error == "invalid_grant") {
                        self.error = this.$t('authentification.errors.signInFailed') as string;
                    }
                    else {
                        self.loadUserInfo();
                    }
                }
                else if(mutation.type === authStore.getActionName(AuthAction.SignInResponseFailed)) {
                    createdSubscriber();
                    self.sending = false;
                    if (mutation.payload.error_description == "email_not_confirmed") {
                        self.error = "Nejprve je nutné ověřit Vaši e-mailovou adresu pomocí již zaslaného ověřovacího e-mailu. Pokud nemůžete zaslaný e-mail najít, zkuste obnovu hesla.";
                    }
                    else {
                        self.error = this.$t('authentification.errors.signInFailed') as string;
                    }
                } else {
                    self.sending = false;
                }
            });
        }
    }

    goToPasswordRecovery () {
        this.$router.replace({ name: "PasswordRecovery" });
    }
    
    goToTenantOrDefault () {
        tenantsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload());
        this.subscribe(tenantsStore, CrudReponse.GetAll).then((e: TenantModel[]) => {
            if (e.length > 0) {
                this.$router.push({ name: "Dashboard", params: { tenantId: e[0].id! } });
                authStore.dispatch(AuthAction.SetTenant, e[0].id!);
            }
            else {
                this.$router.push({ name: "UserSettings" });
            }
        }).catch(() => {
            this.$router.push({ name: "UserSettings" });
        });
    }

    loadUserInfo () {
        const self = this;
        authStore.dispatch(AuthAction.UserInfo);
        applicationUserStore.dispatch(CrudAction.Get, {});
        const subscription = this.$store.subscribe((mutation, _state) => {
            if (mutation.type === applicationUserStore.getActionName(CrudAction.Get)) {
                subscription();
                authStore.dispatch(AuthAction.SetUser, mutation.payload);
                self.goToTenantOrDefault();
            }
        });
    }

}
